<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Modal, Button, Text } from '@Shelly/shelly-design-system';
	import {
		getSharedHomeManagedCopy,
		type SharedHomeManagedContext,
	} from 'src/helpers/houses/shared_home_messaging_helpers';

	export let showModal = false;
	export let context: SharedHomeManagedContext = 'generic';

	const dispatch = createEventDispatcher<{ close: void }>();

	$: copy = getSharedHomeManagedCopy(context);

	const onClose = () => {
		showModal = false;
		dispatch('close');
	};
</script>

<Modal {showModal} title={$format(copy.headingKey, { default: copy.headingDefault })} on:close={onClose}>
	<svelte:fragment slot="content">
		<Text>
			{$format(copy.messageKey, { default: copy.messageDefault })}
		</Text>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			responsiveSize={{ sm: 'm' }}
			on:click={onClose}
			aria-label={$format('button_got_it', { default: 'Okay, got it!' })}
		>
			{$format('button_got_it', { default: 'Okay, got it!' })}
		</Button>
	</div>
</Modal>
